import { render, staticRenderFns } from "./SettingsVerificationPopup.vue?vue&type=template&id=2b683fcf&scoped=true"
import script from "./SettingsVerificationPopup.vue?vue&type=script&lang=ts"
export * from "./SettingsVerificationPopup.vue?vue&type=script&lang=ts"
import style0 from "./SettingsVerificationPopup.vue?vue&type=style&index=0&id=2b683fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b683fcf",
  null
  
)

export default component.exports